export const getPhonePlatform = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/iphone/.test(userAgent))
        return "apple";
    if (/android/.test(userAgent))
        return "google";
    return null;
};
//# sourceMappingURL=getPhonePlatform.js.map